import axios, { AxiosError } from 'axios'
import { COLLECTION_ACCESS, COLLECTION_CARTAO, COLLECTION_TOKEN, COLLECTION_USERS } from '../configs/database'

// URLs relativas de proposito -- resolvem sempre para o mesmo dominio que
// serviu a pagina (portalhml.capul.com.br em homologacao, portalcapul.capul.com.br
// em producao), sem nenhum dominio hardcoded no bundle. O Nginx de cada
// ambiente ja roteia /api/ pro portal-backend certo (ver
// capul_infra_site_portal/nginx/conf.d/*/portal.conf).
//
// "api" chamava o Protheus direto do navegador antes (com credencial Basic
// Auth hardcoded no bundle, exposta a qualquer visitante) -- agora passa
// pelo proxy autenticado do proprio backend (ver
// backend/app/Controllers/Http/ProtheusController.ts). O Protheus real e a
// credencial ficam só no servidor, nunca mais aqui.
const api = axios.create({
  baseURL: '/api/protheus/',
})

const apiLogin = axios.create({
  baseURL: '/api/',
})

// Chamado pelo hooks/auth.tsx apos login/logout/restauracao de sessao --
// anexa o token (Bearer) exigido pelo middleware "auth" do backend em toda
// chamada autenticada (proxy do Protheus e changePassword).
function setAuthToken(token: string | null) {
  const header = token ? `Bearer ${token}` : undefined
  api.defaults.headers.common.Authorization = header as string
  apiLogin.defaults.headers.common.Authorization = header as string
}

// Sessao expirada (12h) ou recusada pelo backend (ex.: token antigo, sem as
// matriculas da sessao): o backend responde 401 e nada mais funciona ate um
// novo login. Sem isto a tela continuava "logada" e todas as consultas davam
// erro. So vale para chamadas que enviaram token -- o proprio login responde
// 400 para senha errada e nunca cai aqui. Limpa as mesmas chaves do signOut
// (hooks/auth.tsx) e recarrega na raiz, que sem sessao mostra a tela de login.
function sairSeSessaoInvalida(error: AxiosError) {
  const enviouToken = Boolean(error.config?.headers?.Authorization)
  if (error.response?.status === 401 && enviouToken) {
    localStorage.removeItem(COLLECTION_USERS)
    localStorage.removeItem(COLLECTION_CARTAO)
    localStorage.removeItem(COLLECTION_ACCESS)
    localStorage.removeItem(COLLECTION_TOKEN)
    setAuthToken(null)
    window.location.assign('/')
  }
  return Promise.reject(error)
}

api.interceptors.response.use((response) => response, sairSeSessaoInvalida)
apiLogin.interceptors.response.use((response) => response, sairSeSessaoInvalida)

export { api, apiLogin, setAuthToken }
